// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3__ar","label":"styles_label__37gKN"};